import {IBrowserTabState} from '@toolify/client/src/modules/broadcast/types/IBrowserTabState'

export const BROWSER_TAB_ACTIVE_CLAIM_TTL_MS = 30000

export const BROWSER_TAB_PRESENCE_TTL_MS = 180000

interface IRankedBrowserTabState extends IBrowserTabState {
  hasActiveClaim: boolean
}

export function hasBrowserTabActiveClaim(tabState: IBrowserTabState, now: number) {
  return now - tabState.updatedAt < BROWSER_TAB_ACTIVE_CLAIM_TTL_MS
}

export function isBrowserTabPresent(tabState: IBrowserTabState, now: number) {
  return now - tabState.updatedAt < BROWSER_TAB_PRESENCE_TTL_MS
}

function compareBrowserTabStates(a: IRankedBrowserTabState, b: IRankedBrowserTabState) {
  if(a.isFocused !== b.isFocused) {
    return a.isFocused ? -1 : 1
  }
  if(a.isVisible !== b.isVisible) {
    return a.isVisible ? -1 : 1
  }
  if(a.hasActiveClaim !== b.hasActiveClaim) {
    return a.hasActiveClaim ? -1 : 1
  }
  if(a.lastActiveAt !== b.lastActiveAt) {
    return b.lastActiveAt - a.lastActiveAt
  }
  if(a.openedAt !== b.openedAt) {
    return b.openedAt - a.openedAt
  }
  return a.tabId < b.tabId ? -1 : 1
}

export function getPrimaryBrowserTabId(tabStates: IBrowserTabState[], localTabId: string, now: number) {
  const rankedTabStates = tabStates
    .filter(tabState => tabState.tabId === localTabId || isBrowserTabPresent(tabState, now))
    .map((tabState): IRankedBrowserTabState => {
      const hasActiveClaim = hasBrowserTabActiveClaim(tabState, now)
      if(hasActiveClaim) {
        return {
          ...tabState,
          hasActiveClaim,
        }
      }
      return {
        ...tabState,
        hasActiveClaim,
        isVisible: false,
        isFocused: false,
      }
    })
    .sort(compareBrowserTabStates)

  return rankedTabStates[0]?.tabId ?? localTabId
}
